import { ReactNode } from 'react';
import { connect } from 'react-redux';

import {
  hideModal as hideModalAction,
  showModal as showModalAction,
} from 'store/main/ducks/modal';

type OwnProps = {
  render: (
    arg0: typeof showModalAction,
    arg1: typeof hideModalAction | null | undefined
  ) => ReactNode;
};
type Props = OwnProps & {
  showModal: typeof showModalAction;
  hideModal: typeof hideModalAction;
};

const ShowModalContainer = ({ render, showModal, hideModal }: Props) =>
  render(showModal, hideModal);

// @ts-expect-error ts-migrate(2558) FIXME: Expected 5 type arguments, but got 6.
// eslint-disable-next-line import/no-default-export
export default connect<Props, OwnProps, _, _, _, _>(null, {
  showModal: showModalAction,
  hideModal: hideModalAction,
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '({ render, showModal, hideModal ... Remove this comment to see the full error message
})(ShowModalContainer);
